// extracted by mini-css-extract-plugin
export default {"inputGroup":"Input_inputGroup__GON0L","input":"Input_input__Ba4RU","label":"Input_label__XvWTY"};